export default "__VITE_ASSET__C$Q_neG9__"